export default "__VITE_ASSET__EkgCQrVP__"